module.exports = __webpack_public_path__ + "static/media/Chemists.4a18d562.svg";